import {Button, Form, Modal} from 'antd'
import {FormikProvider, useFormik} from 'formik'
import * as React from 'react'
import {useEffect} from 'react'
import {useMutation, useQuery, useQueryClient} from 'react-query'
import {RouteConfigComponentProps} from 'react-router-config'
import {useHistory, useParams} from 'react-router-dom'
import * as Yup from 'yup'
import {FInput, FMoney, FormGroup, FTextArea} from '../../../components/form/FormInputs'
import {qs} from '../../queries'
import {ProcedureModel} from '../../typings'

type ProcedureDetailPageProps = RouteConfigComponentProps

type FormValues = { [K in keyof ProcedureModel]?: ProcedureModel[K] | '' }

export const ProcedureDetailPage: React.FC<ProcedureDetailPageProps> = (props) => {
  const { item_id } = useParams<{ item_id: string }>()
  const history = useHistory()
  const queryClient = useQueryClient()

  const cur_item = useQuery(['getProcedure', item_id], () => qs.procedures.get(item_id), {
    enabled: false,
    retry: false
  })

  const create = useMutation(values => qs.procedures.post(values), {
    onSuccess: () => handleCancel()
  })
  const update = useMutation(values => qs.procedures.patch(values))

  useEffect(() => {
    cur_item.refetch()
  }, [item_id])

  let mutating = create.isLoading || update.isLoading

  const handleCancel = () => {
    queryClient.removeQueries(['getProcedure', item_id], { inactive: true, stale: true })

    setTimeout(() => {
      history.push('/procedures')
    }, 200)
  }

  const formikBag = useFormik<FormValues>({
    enableReinitialize: true,
    initialValues: {
      id: cur_item.data?.id ?? '',
      name: cur_item.data?.name ?? '',
      amount: cur_item.data?.amount ?? '0',
      contract_clause: cur_item.data?.contract_clause ?? ''
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required()
    }),
    onSubmit: (values: any) => {
      if (cur_item.data?.id) {
        update.mutate(values)
      } else {
        create.mutate(values)
      }
    }
  })

  return (
    <React.Fragment>
      <Modal
        visible={true}
        maskClosable
        destroyOnClose
        onCancel={handleCancel}
        width={650}
        closable={false}
        footer={[
          <Button key="2" type="default" onClick={handleCancel}>Fechar</Button>,
          <Button key="1" type="primary" onClick={formikBag.submitForm} loading={mutating}>Salvar</Button>
        ]}
      >
        {!cur_item.isLoading &&
          <FormikProvider value={formikBag}>
            <Form layout="vertical">
              <FormGroup>
                <FInput name="name" label="Nome"/>
                <FMoney name="amount" label="Valor"/>
              </FormGroup>

              <FTextArea name="contract_clause" label="Cláusula do contrato"/>
            </Form>
          </FormikProvider>}
      </Modal>
    </React.Fragment>
  )
}
